(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('socialHistoryComponent', socialHistoryComponent);

    socialHistoryComponent.$inject = [];

    function socialHistoryComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveSocialHistoryComponentController,
            templateUrl: 'app/npq-questionnaire/workflow/partial/directive/social-history.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveSocialHistoryComponentController.$inject = ['$scope', '$stateParams', '$element', '$timeout'];
    function DirectiveSocialHistoryComponentController($scope, $stateParams, $element, $timeout) {
        
        function init() {
        }

        init();
    }
})();
